var _rect, _pattern, _rect2, _path, _text, _g, _g2, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqBannerAlt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#EC4899",
      stopOpacity: 0.05
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#bgGradient)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#4F46E5",
    strokeWidth: 0.5,
    opacity: 0.1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#grid)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 240,
    height: 240,
    rx: 20,
    fill: "white",
    style: {
      filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 140             C140 140, 135 140, 135 145             L135 175             C135 180, 140 180, 140 180             L170 180             C175 180, 175 175, 175 175             L175 145             C175 140, 170 140, 170 140 Z",
    fill: "#4F46E5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 180,
    fontFamily: "Arial",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#1E293B",
    textAnchor: "middle"
  }, "\n    FAQs\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 240)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 40,
    fill: "none",
    stroke: "#4F46E5",
    strokeWidth: 2,
    strokeDasharray: "6 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "none",
    stroke: "#EC4899",
    strokeWidth: 2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -10               C-10 -20, 10 -20, 10 -10              C10 -5, 0 -2, 0 5              L0 15",
    stroke: "#4F46E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 20,
    r: 2,
    fill: "#4F46E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 280,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 300,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 280,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 280,
    x2: 200,
    y2: 300,
    stroke: "#EC4899",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 300,
    x2: 240,
    y2: 280,
    stroke: "#EC4899",
    strokeWidth: 1.5
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 340,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#6B7280",
    textAnchor: "middle"
  }, "\n    Got questions? We've got answers!\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBannerAlt1);
export default __webpack_public_path__ + "static/media/faq-banner-alt (1).f889bdc82a12abe38f7879bc5289df7c.svg";
export { ForwardRef as ReactComponent };